const addKeyTo = (models, { keyAttr } = { keyAttr: 'id' }) =>
  models.map(model => ({
    ...model,
    key: model[keyAttr],
  }));

export default addKeyTo;
